module.exports = __webpack_public_path__ + "img/pluto115.e84c9de2.jpg";